import { ModulesMap } from '@/config/data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'
import { dataTransferWrapWithIncludedApiModule } from '../dataTransferService'
import NotificationsApi from '@/services/apiServiceModules/notificationsApi'
import DataTransferModule from '@/services/dataTransferModule'

const notificationsApi = new NotificationsApi()

export default class NotificationsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.NOTIFICATIONS, notificationsApi)
	}

	/**
	 * Счётчик непрочитанных — кешируется отдельно от основного списка уведомлений
	 * (в старом дт-конфиге кеш был указан только для этого метода, не для всей сущности).
	 */
	getNotificationsUnreadCount(companyId, query) {
		return dataTransferWrapWithIncludedApiModule(
			this.moduleName,
			this.apiModule,
			{
				apiServiceMethodName: 'getNotificationsUnreadCount',
				useCache: true,
				cacheStorage: STORE_MAP.FULL,
			},
			{
				urlParams: {
					companyId,
				},
				params: query,
			},
		)
	}

	getNotificationsSettings(companyId) {
		return dataTransferWrapWithIncludedApiModule(
			this.moduleName,
			this.apiModule,
			{ apiServiceMethodName: 'getNotificationsSettings' },
			{
				urlParams: {
					companyId,
				},
			},
		)
	}

	patchNotificationsSettings(companyId, notificationSettingId, body) {
		return dataTransferWrapWithIncludedApiModule(
			this.moduleName,
			this.apiModule,
			{ apiServiceMethodName: 'patchNotificationsSettings' },
			{
				urlParams: {
					companyId,
					entityId: notificationSettingId,
				},
				...body,
			},
		)
	}

	patchNotificationsMarkAllRead(companyId, body) {
		return dataTransferWrapWithIncludedApiModule(
			this.moduleName,
			this.apiModule,
			{ apiServiceMethodName: 'patchNotificationsMarkAllRead' },
			{
				urlParams: {
					companyId,
				},
				...body,
			},
		)
	}

	patchNotificationsMarkReadStatus(companyId, body) {
		return dataTransferWrapWithIncludedApiModule(
			this.moduleName,
			this.apiModule,
			{ apiServiceMethodName: 'patchNotificationsMarkReadStatus' },
			{
				urlParams: {
					companyId,
				},
				...body,
			},
		)
	}
}
